import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {SourceTypeCode} from '../../shared/constants';

interface TallyData {
  id: any;
  type: any;
  filters: any;
  label: any;
  idLabels: any;
}

interface TallyResponse {
  reportId: number;
  notificationid: number;
  reportPath: string;
  reportName: string;
  reportType: string;
}

interface TallyDocs {
  dataasof: string;
  list: any;
  docs: any;
}

interface SubTallyDocs {
  dataasof: string;
  list: any;
  docs: any;
}

interface TallyExportData {
  docId: number;
}

interface SubtallyExportData {
  docId: number;
}

interface TallyState {
  selectedSource: any;
  tallyData: TallyData | null;
  tallyResponse: TallyResponse | null;
  tallyResult: TallyDocs | null;
  subtallyData: TallyData | null;
  subtallyResponse: TallyResponse | null;
  subtallyResult: SubTallyDocs | null;
  tallyExportData: TallyExportData | null;
  subtallyExportData: SubtallyExportData | null;
  activeActionContext: SourceTypeCode | null;
  preTallySelects: any | null;
}
const initialState: TallyState = {
  selectedSource: null,
  tallyData: null,
  tallyResponse: null,
  tallyResult: null,
  subtallyData: null,
  subtallyResponse: null,
  subtallyResult: null,
  tallyExportData: null,
  subtallyExportData: null,
  activeActionContext: null,
  preTallySelects: null,
};

type TallyPartial = Partial<TallyState>;

const tallyReportSlice = createSlice({
  name: 'tallyreport',
  initialState,
  reducers: {
    updateTally: (state, action: PayloadAction<TallyPartial>) => {
      Object.assign(state, action.payload);
    },

    clearMainTally: (state) => {
      Object.keys(state).forEach((key) => ((state as any)[key] = null));
    },

    clearSubTally: (state) => {
      state.subtallyData = null;
      state.subtallyResponse = null;
      state.subtallyResult = null;
    },

    clearTally: (state) => {
      state.tallyData = null;
      state.tallyResponse = null;
      state.tallyResult = null;
    },

    setActiveActionContext: (
      state,
      action: PayloadAction<SourceTypeCode | null>
    ) => {
      state.activeActionContext = action.payload;
    },
    clearActiveActionContext: (state) => {
      state.activeActionContext = null;
    },
    setPreTallySelects: (state, action: PayloadAction<any | null>) => {
      state.preTallySelects = action.payload;
    },
    clearPreTallySelects: (state) => {
      state.preTallySelects = null;
    },
  },
});

export const {
  updateTally,
  clearTally,
  clearSubTally,
  clearMainTally,
  setActiveActionContext,
  clearActiveActionContext,
  setPreTallySelects,
  clearPreTallySelects,
} = tallyReportSlice.actions;

export default tallyReportSlice.reducer;
